module.exports = __webpack_public_path__ + "static/img/slide4.ab07b52e.jpg";